import Highcharts from "highcharts";
import { TIChartPointModel } from "../../../models/data-point/ti-chart-point.model";
import { IComponent } from "../../component.interface";
import { IDrawingTool } from "../drawing-tool.interface";
import { DrawingToolsManager } from "../drawing-tools.manager";

export class FlagsComponent implements IComponent, IDrawingTool {
    public id = '';

    public annotation: any = null;
    private drawingToolManager: DrawingToolsManager;

    constructor(drawingToolManager: DrawingToolsManager, id: string) {
        this.drawingToolManager = drawingToolManager;
        this.id = id;
    }

    public static syncCreate(drawingToolManager: DrawingToolsManager, annotationOptions: any): FlagsComponent {
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;

        if (annotationOptions.startTimeT) {
            const point = drawingToolManager.base.tiChartSeries.tiChartPoints.find((x: TIChartPointModel) => x.startTimeT == annotationOptions.startTimeT);
            if (annotationOptions.data?.length) {
                annotationOptions.data[0].x = point.xValue;
            }
        }

        // TraceLoggingHelpers.log('  chart.navigationBindings ',  chart.navigationBindings)
        annotationOptions.point = {
            events: {
                click: function () {
                    var point = this, options = point.options;
                    Highcharts.fireEvent(chart.navigationBindings, 'showPopup', {
                        point: point,
                        formType: 'annotation-toolbar',
                        options: {
                            langKey: 'flags',
                            type: 'flags',
                            title: [
                                options.title,
                                'text'
                            ],
                            name: [
                                options.name,
                                'text'
                            ]
                        },
                        onSubmit: function (updated) {
                            if (updated.actionType === 'remove') {
                                point.remove();
                            }
                            else {
                                point.update(chart.navigationBindings.fieldsToOptions(updated.fields, {}));
                            }
                        }
                    });
                }
            }
        }

        const addedNewAnnotation: any = chart.addSeries(annotationOptions);

        const component = new FlagsComponent(drawingToolManager, annotationOptions.id);
        component.annotation = addedNewAnnotation;
        return component;
    }

    public static create(drawingToolManager: DrawingToolsManager, event: any): FlagsComponent {
        const component = new FlagsComponent(drawingToolManager, event.options.id);
        component.annotation = event;
        return component;
    }

    public syncUpdate(annotationOptions: any) {
        this.annotation.update(annotationOptions);
        this.drawingToolManager.updateAnnotationStyles(this.annotation, annotationOptions, false);
    }

    public getMetaData(): any {
        let startTimeT: number | null = null;
        if (this.annotation.userOptions.data?.length) {
            const xValue = this.annotation.userOptions.data[0].x;
            const point = this.drawingToolManager.base.tiChartSeries.tiChartPoints.find((x: TIChartPointModel) => x.xValue == xValue);
            startTimeT = point.startTimeT
        }

        return {
            id: this.id,
            type: 'flags',
            xAxis: this.annotation.userOptions.xAxis,
            yAxis: this.annotation.userOptions.yAxis,
            shape: this.annotation.userOptions.shape,
            startTimeT: startTimeT,
            data: this.annotation.userOptions.data,
        };
    }
}